import React, {PropTypes} from 'react';
import { map } from 'lodash';
import DropDownMenu from '../../../common/components/c_DropDownMenu';
import TextField from '../../../common/components/c_TextField';
import DateInputDropDown from '../../../common/components/DateInputDropDown';

function StateAuthority(props) {
  const {
    label,
    value,
    clientId,
    stateList
  } = props;

  const handleChange = (event, val) => {
    if (props.onChange) {
      props.onChange(event, val);
    }
  };

  if (label) {
    return (
      <DropDownMenu
        style={{display: 'block'}}
        data-id={`License Types ${clientId}`}
        canAutoPosition='true'
        floatingLabelText={label}
        value={value}
        onChange={handleChange}
        menuItems={stateList}
      />
    );
  }
}

StateAuthority.propTypes = {
  stateList : PropTypes.array.isRequired,
  label     : PropTypes.string,
  value     : PropTypes.number,
  clientId  : PropTypes.string,
  onChange  : PropTypes.func
};

function RenewalDate(props) {
  const {
    label,
    value,
    clientId
  } = props;

  const handleChange = (event) => {
    if (props.onChange && event.target.value) {
      props.onChange(event, event.target.value);
    }
  };

  if (label) {
    return (

      <DateInputDropDown
        floatingLabelText={label}
        data-id={`Renewal Anniversary Date ${clientId}`}
        dateFormat={'MonthYear'}
        hintText={'12/1999'}
        autoOk
        includeFuture='true'
        value={value}
        onChange={handleChange}
      />

    );
  }
}

RenewalDate.propTypes = {
  label     : PropTypes.string,
  value     : PropTypes.number,
  clientId  : PropTypes.string,
  onChange  : PropTypes.func
};

function LicenseTypes(props) {

  const {
    label,
    value,
    menuItems
  } = props;

  const onChange = (event, val) => {
    if (props.onChange) {
      props.onChange(event, val);
    }
  };

  return (
    <DropDownMenu
      data-id='License Types'
      floatingLabelText={label}
      menuItems={menuItems}
      value={value}
      onChange={onChange}
      errorText={!!value ? null : 'This field is required'}
    />
  );
}

LicenseTypes.propTypes = {
  menuItems   : PropTypes.array.isRequired,
  label       : PropTypes.string,
  value       : PropTypes.number,
  onChange    : PropTypes.func
};

function LicenseOther(props) {

  const {
    label,
    value,
    licenseStatuses
  } = props;

  const handleChange = (event, val) => {
    if (props.onBlur) {
      return props.onBlur(event, val);
    }
  };

  const other = licenseStatuses.find(l => l.subElement === 'Other');
  if (other && props.licenseTypeId === other.id) {
    return (
      <TextField
        floatingLabelText={label}
        defaultValue={value}
        onBlur={handleChange}
      />
    );
  }

  return null;
}

LicenseOther.propTypes = {
  licenseStatuses : PropTypes.array.isRequired,
  licenseTypeId   : PropTypes.number,
  label           : PropTypes.string,
  value           : PropTypes.string,
  onBlur          : PropTypes.func
};

function License(props) {

  const handleUpdate = (property) =>
    (event, value) => {
      if (props.onChange) {
        props.onChange(event, property, value);
      }
    }
  ;

  const handleRemove = () => {
    if (props.onRemove) {
      props.onRemove();
    }
  };

  return (
    <div className='license form-contents dropdown-larger-width'>
      <StateAuthority
        stateList={props.staticData.stateList}
        label={props.labels.state}
        value={props.state}
        clientId={props.clientId}
        onChange={handleUpdate('state')}
      />
      <div
        className='force-wrap'
      />
      <RenewalDate
        label={props.labels.renewalDate}
        value={props.renewalDate}
        clientId={props.clientId}
        onChange={handleUpdate('renewalDate')}
      />
      <LicenseTypes
        label={'Please select your licenses from the list below'}
        menuItems={props.staticData.licenseTypes}
        value={props.licenseTypeId}
        onChange={handleUpdate('licenseTypeId')}
      />
      <LicenseOther
        label={'Specify License'}
        licenseStatuses={props.staticData.licenseTypes}
        licenseTypeId={props.licenseTypeId}
        value={props.licenseName}
        onBlur={handleUpdate('licenseName')}
      />
      <div
        data-id='remove-section'
        className='remove-section text-btn noTextSelect'
        onClick={handleRemove}>
        Remove License
      </div>
    </div>
  );
}

License.propTypes = {
  staticData    : PropTypes.object.isRequired,
  labels        : PropTypes.object.isRequired,
  clientId      : PropTypes.string.isRequired,
  state         : PropTypes.number,
  licenseTypeId : PropTypes.number,
  licenseName   : PropTypes.string,
  renewalDate   : PropTypes.object,
  onChange      : PropTypes.func,
  onRemove      : PropTypes.func
};

export default function Licenses(props) {

  const {licenses} = props;

  const handleChange = (clientId) =>
    (event, property, value) => {
      if (props.onChange) {
        props.onChange(event, clientId, property, value);
      }
    }
  ;

  const handleRemove = (clientId) =>
    () => {
      if (props.onRemove) {
        props.onRemove(clientId);
      }
    }
  ;

  return (
    <div>
      {
        map(licenses, license =>
          <License
            key={license.clientId}
            staticData={props.staticData}
            labels={props.labels}
            clientId={license.clientId}
            state={license.state}
            licenseTypeId={license.licenseTypeId}
            licenseName={license.licenseName}
            renewalDate={license.renewalDate}
            onChange={handleChange(license.clientId)}
            onRemove={handleRemove(license.clientId)}
          />
        )
      }
    </div>
  );

}

Licenses.propTypes = {
  licenses    : PropTypes.object.isRequired,
  staticData  : PropTypes.object.isRequired,
  labels      : PropTypes.object.isRequired,
  onChange    : PropTypes.func,
  onRemove    : PropTypes.func
};



// WEBPACK FOOTER //
// ./shared/react/applicant/LicensesForm/Licenses.js